// Element Plus 对话框拖拽包装组件（替代 Vue2 时代的 v-el-drag-dialog 指令）。
// 背景：EP 的 ElDialog 根节点是 Teleport，Vue3 自定义指令挂在其上钩子永不触发
// （renderComponentRoot 会警告 "Runtime directive used on component with non-element root node"）。
// 改为组件封装：内部渲染 ElDialog，在弹窗打开（updated）后给 header 绑定拖拽。
// 用法与 el-dialog 完全一致：<drag-dialog width="500px" title="x" v-model="visible">...</drag-dialog>
// props/事件经 $attrs 原样透传，所有插槽透传到 ElDialog；拖拽过程会 emit 'dragDialog' 事件。
import { h } from 'vue'
import { ElDialog } from 'element-plus'

function bindDrag(inst) {
  // EP 2.14 ElDialog expose 的 dialogContentRef 指向内部 dialog-content 组件（根元素即 .el-dialog）
  let dragDom = inst && inst.dialogContentRef
  if (dragDom && dragDom.$el) dragDom = dragDom.$el
  if (!dragDom || dragDom.nodeType !== 1) return
  const header = dragDom.querySelector('.el-dialog__header') ||
    (dragDom.classList.contains('el-dialog__header') ? dragDom : null)
  if (!header || header.__dragBound) return
  header.__dragBound = true

  header.style.cssText += ';cursor:move;'
  dragDom.style.cssText += ';top:0px;'

  const getStyle = (dom, attr) => getComputedStyle(dom, false)[attr]

  header.onmousedown = (e) => {
    // 鼠标按下，计算当前元素距离可视区的距离
    const disX = e.clientX - header.offsetLeft
    const disY = e.clientY - header.offsetTop

    const dragDomWidth = dragDom.offsetWidth
    const dragDomheight = dragDom.offsetHeight

    const screenWidth = document.body.clientWidth
    const screenHeight = document.body.clientHeight

    const minDragDomLeft = dragDom.offsetLeft
    const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth

    const minDragDomTop = dragDom.offsetTop
    const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight

    // 获取到的值带px 正则匹配替换
    let styL = getStyle(dragDom, 'left')
    let styT = getStyle(dragDom, 'top')

    if (styL.includes('%')) {
      styL = +document.body.clientWidth * (+styL.replace(/%/g, '') / 100)
      styT = +document.body.clientHeight * (+styT.replace(/%/g, '') / 100)
    } else {
      styL = +styL.replace(/px/g, '')
      styT = +styT.replace(/px/g, '')
    }

    document.onmousemove = function(e) {
      // 通过事件委托，计算移动的距离
      let left = e.clientX - disX
      let top = e.clientY - disY

      // 边界处理
      if (-left > minDragDomLeft) {
        left = -minDragDomLeft
      } else if (left > maxDragDomLeft) {
        left = maxDragDomLeft
      }

      if (-top > minDragDomTop) {
        top = -minDragDomTop
      } else if (top > maxDragDomTop) {
        top = maxDragDomTop
      }

      // 移动当前元素
      dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`

      // emit onDrag event（与原 v-el-drag-dialog 指令行为一致）
      inst.$emit && inst.$emit('dragDialog')
    }

    document.onmouseup = function() {
      document.onmousemove = null
      document.onmouseup = null
    }
  }
}

export default {
  name: 'DragDialog',
  inheritAttrs: false,
  mounted() { this.bindDrag() },
  updated() { this.bindDrag() },
  methods: {
    bindDrag() {
      // nextTick：弹窗打开（modelValue 变化）触发 updated 后，EP 以 v-if 重建 dialog DOM
      this.$nextTick(() => bindDrag(this.$refs.dlgRef))
    },
  },
  render() {
    return h(ElDialog, { ref: 'dlgRef', ...this.$attrs }, this.$slots)
  },
}
